var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"donut-chart mx-auto"},[_c('h1',{staticClass:"my-4 grey--text text--darken-1 display-1 font-weight-bold text-xs-center"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('apexchart',{attrs:{"type":"donut","options":_vm.chartOptions,"series":_vm.series}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }